import { createRouter, RouteRecordRaw } from 'vue-router'

import { createHistory } from '@/router/createWebHistory'

import Apply from '../views/Apply.vue'
import Claim from '../views/Claim.vue'

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'Apply',
		component: Apply,
	},
	{
		path: '/claim/:referralId',
		name: 'Claim',
		component: Claim,
	},
]

const router = createRouter({
	history: createHistory('referrals.dishformyrv.com'),
	routes,
})

export default router
